export const environment = {
  production: "true",
  adfsAuthority: "https://auth.alliedpilots.org/adfs/",
  myTripApiUrl: "https://mytripservice.alliedpilots.org",
  imaxApiUrl: "https://apa-dev-shapim-apim.azure-api.net/IMax",
  apimSubscriptionKey: "cdf7fd42c0174e878b16fcaea51cde75",
  clientId: "https://imaxcalculator.alliedpilots.org",
};
